import palette from 'src/designSystem/variables/palette'
import { DepartmentChip } from 'src/pages/Controls/DepartmentChip'
import styled from 'styled-components/macro'

export const LinkagesDepartmentChip = styled(DepartmentChip)`
  height: 40px;
  border-color: ${palette.neutral[200]};
  padding: 8px 10px;
`
